import { render } from "./ListProvidersPage.vue?vue&type=template&id=109b496a&ts=true"
import script from "./ListProvidersPage.vue?vue&type=script&lang=ts"
export * from "./ListProvidersPage.vue?vue&type=script&lang=ts"

import "./ListProvidersPage.vue?vue&type=style&index=0&id=109b496a&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__